import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 3.5C10.5 5.433 8.933 7 7 7C5.067 7 3.5 5.433 3.5 3.5C3.5 1.567 5.067 0 7 0C8.933 0 10.5 1.567 10.5 3.5ZM0.320485 13.4C1.21249 10.56 3.86568 8.50003 7.00001 8.50003C10.1343 8.50003 12.7875 10.56 13.6795 13.4C13.7752 13.7044 13.5371 14 13.218 14H0.782046C0.462933 14 0.22486 13.7044 0.320485 13.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }